'use strict';

var angular = require('angular');
var dependencies = ['AVRO.Common.Moment', 'AVRO.Common.Formatting'];
module.exports = angular.module('AVRO.Common.Callout', dependencies).directive('rmCallout', require('./directives/CalloutDirective')).controller('CalloutController', require('./controllers/CalloutController'));